// extracted by mini-css-extract-plugin
export var active = "mainPages-module--active--Cvzxx";
export var heading = "mainPages-module--heading--pnYas";
export var link = "mainPages-module--link--Vj7UE";
export var links = "mainPages-module--links--aWdCe";
export var section = "mainPages-module--section--0iV98";
export var show = "mainPages-module--show--Ve1-H";